import React from 'react'
export default function DLContents (props) {
  return (
      <>
  DOWNLOAD CONTENTS
    </>
  )
}
